// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vue-notification-group {
  position: fixed;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./src/components/table/vNotification.vue"],"names":[],"mappings":";AAYA;EACA,eAAA;EACA,aAAA;AACA","sourcesContent":["<template>\n  <notifications\n      class=\"tm-notifications\" position=\"top right\">\n  </notifications>\n</template>\n\n<script>\nexport default {\n  name: \"vNotification\",\n}\n</script>\n<style>\n.vue-notification-group {\n  position: fixed;\n  z-index: 9999;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
